<template>
  <div>
    <div class="clear"></div>
    <!-- Content

    


    =============================================-->
    <section id="content" style="max-width: 1280px; margin-left: auto; margin-right: auto;">
      <div class="content-wrap">
        <div class="container" style="max-width: 1200px;">
          <div class="single-product">
            <div style="max-width:1150px;">
              <div class="row" style="width:100% !important; ">
                <!-- ครึ่งรูปภาพ -->
                <div class="col-lg-6 col-md-6 col-12">
                  <div class="row">
                    <div
                      id="imageselect"
                      class="col-lg-2 col-md-2 col-2 custom-scrollbar"
                      style="padding:0;overflow-y:auto; overflow-x:hidden; max-height: 360px; padding-left:10px; padding-right:10px; "
                    >
                      <div
                        class="oc-item"
                        style="width:60px; margin-bottom:7px; margin-top: 10px; cursor: pointer;"
                        v-for="(im, imgind) in imagelist"
                        :key="imgind"
                      >
                        <img
                          @click="changeImage(im)"
                          class
                          :src="imagePath(im.image)"
                          alt="Gallery Thumb"
                        />
                      </div>
                    </div>
                    <!--col-2-->
                    <div id="mainimage_wrapper" class="col-lg-10 col-md-10 col-10">
                      <img
                        :src="imagePath(theImage)"
                        id="mainimage"
                        style="width: 100%;"
                        alt="Wintershop Dress"
                      />
                    </div>
                    <!--col-10-->
                  </div>

                  <!-- Product Single - Gallery
                  =============================================-->
                </div>

                <div
                  class="col-lg-6 col-md-6 col-12 product-desc"
                  style="padding-left:60px; text-align: left;"
                >
                  <!-- ชื่อสินค้า  -->
                  <div class="row">
                    <div class="col-9">
                      <h3 style="margin-bottom:0; font-size:1.7rem ; font-weight:bold;">{{productGroup.name}}</h3>
                    </div>
                  </div>
                  <!-- โชว์ rental price  -->
                  <div class="row">
                    <div class="col-12">
                      <span style="font-size:16px;">ราคา {{ formatPrice(productGroup.rentalPrice) }} บาท</span>
                      <br />
                      <span
                        style="font-size:12px; color:#F0464F; font-weight:bold;"
                      >( ค่าประกันสินค้า {{ formatPrice(productGroup.bail) }} บาท )</span>
                    </div>
                  </div>
                  <div class="line"></div>

                  <span
                    style="font-size: 13px; font-family:'EkkamaiNew' ;"
                    v-html="main.webDescription"
                  ></span>

                  <br />
                  <!-- โชว์สี  -->
                  <div class="row">
                    <div class="col-9">
                      <h3 class="theTitle" style="margin-top: 10px; margin-bottom: -2px;">สี</h3>
                    </div>
                    <div class="col-12">
                      <div role="group" aria-label="Basic example">
                        <div
                          :class="{choose: colorSelected === ic}"
                          class="button button-medium button-border button-rounded color-btn"
                          style="flow:left !important;  font-family:'Mitr' , 'supermarket' !important; font-size: 14px !important; font-weight: 300"
                          @click="selectColor(ic)"
                          v-for="(ic,colorind) in itemColors"
                          :key="colorind"
                        >{{getColorName(ic)}}</div>
                      </div>
                    </div>
                  </div>
                  <!-- ไซส์ -->
                  <div class="row">
                    <div class="col-12">
                      <h3 class="theTitle" style="margin-bottom: -2px;">ขนาด</h3>
                    </div>
                    <div class="col-12">
                      <div role="group" aria-label="Basic example">
                        <div
                          @click="selectSize(is)"
                          :class="{choose: sizeSelected === is}"
                          class="button button-medium button-border button-rounded nc_size"
                          style="flow:left;  font-family:supermarket; font-size: 14px !important;"
                          v-for="(is,sizeind) in itemSizes"
                          :key="sizeind"
                        >{{is}}</div>
                      </div>
                    </div>
                  </div>
                  <!-- ROW -->
                  <div class="row">
                    <div class="col-12">
                      <h3 class="theTitle" style="margin-top: 10px; margin-bottom: -2px;">สาขา</h3>
                    </div>
                    <div class="col-12">
                      <div role="group" aria-label="Basic example">
                        <div
                          @click="selectBranch(brn)"
                          :class="{choose: branchSelected === brn}"
                          class="button button-medium button-border button-rounded nc_size"
                          style="font-family:supermarket; font-size: 14px !important;"
                          v-for="(brn,brnind) in branchlist"
                          :key="brnind"
                        >{{brn.branchName}}</div>
                      </div>
                    </div>
                  </div>
                  <!-- ROW -->
                  <br />
                  <h3
                    style="margin-top: 5px; margin-bottom: -2px;"
                    class="theTitle"
                  >วันรับและคืนสินค้า</h3>
                  <!-- รับและคืนสินค้า -->
                  <div class="row">
                    <div class="col-lg-9 col-md-9 col-11">
                   
 <!-- COMMENT BY BELL -->
                       <v-date-picker
                        @click="clickdate()"
                        :locale="{ id: 'th', firstDayOfWeek: 2, masks: {  L: 'DD/MM/YYYY' } }"
                        mode="range"
                        v-model="range"
                      /> 
 <!-- COMMENT BY BELL -->
                    </div>
                    <br />

                    <form
                      class="cart nobottommargin clearfix"
                      method="post"
                      enctype="multipart/form-data"
                    >
                      <div class="quantity clearfix"></div>
                    </form>
                  </div>
                  <!-- ระบุจำนวน -->
                  <div class="row" style="margin-top:20px;">
                    <div class="col-lg-3 col-md-3 col-4" style="padding-top:5px;">
                      <select
                        class="form-control"
                        id="exampleFormControlSelect1"
                        v-model="optitemSelected"
                        style="font-size:13px;"
                      >
                        <option value="0">ระบุจำนวน</option>
                        <option v-for="(opt,opt_ind) in optitem" :key="opt_ind">{{opt}}</option>
                      </select>
                    </div>
                    <div class="col-lg-3 col-md-3 col-4" style="padding-left:5px;">
                      <div
                        class="button button-rounded button-green"
                        @click="checkq()"
                      >เช็คคิวสินค้า</div>
                    </div>
                  </div>
                  <!-- VALIDATE INPUT ERROR -->
                  <div class="row" v-show="colorShow">
                    <div
                      class="alert alert-danger col-lg-10 col-md-10 col-10"
                      style="font-size:13px;"
                    >
                      <i class="icon-remove-sign"></i>
                      <strong>โปรดระบุสี</strong>
                    </div>
                  </div>
                  <div class="row" v-show="sizeShow">
                    <div
                      class="alert alert-danger col-lg-10 col-md-10 col-10"
                      style="font-size:13px;"
                    >
                      <i class="icon-remove-sign"></i>
                      <strong>โปรดระบุขนาด</strong>
                    </div>
                  </div>
                  <div class="row" v-show="branchShow">
                    <div
                      class="alert alert-danger col-lg-10 col-md-10 col-10"
                      style="font-size:13px;"
                    >
                      <i class="icon-remove-sign"></i>
                      <strong>โปรดระบุสาขาที่ต้องการรับ</strong>
                    </div>
                  </div>
                  <div class="row" v-show="rentalDateShow">
                    <div
                      class="alert alert-danger col-lg-10 col-md-10 col-10"
                      style="font-size:13px;"
                    >
                      <i class="icon-remove-sign"></i>
                      <strong>โปรดระบุวันรับและคืนสินค้า</strong>
                    </div>
                  </div>
                  <div class="row" v-show="optitemShow">
                    <div
                      class="alert alert-danger col-lg-10 col-md-10 col-10"
                      style="font-size:13px;"
                    >
                      <i class="icon-remove-sign"></i>
                      <strong>โปรดระบุจำนวนสินค้าที่ต้องการ</strong>
                    </div>
                  </div>
                  <div class="row" v-show="checkq_dup">
                    <div
                      class="alert alert-danger col-lg-10 col-md-10 col-10"
                      style="font-size:13px;"
                    >
                      <!-- <i class="icon-remove-sign"></i> -->
                      <strong>มีสินค้านี้ในตระกร้าแล้ว!</strong> หากกดปุ่มเพิ่มสินค้าลงตะกร้า สินค้ารายการใหม่จะทับข้อมูลรายการเดิม
                    </div>
                  </div>
                  <div class="row" style="margin-top:20px;">
                    <div
                      class="alert alert-success col-lg-12 col-md-12 col-12"
                      style="font-size: 13px;"
                      v-show="checkq_result === 1"
                    >
                      <i class="icon-smile-beam1"></i>
                      <strong>สินค้ายังมีว่างอยู่ค่ะ !</strong> กดปุ่มด้านล่างเพื่อเพิ่มสินค้าลงตะกร้า
                    </div>
                    <div
                      class="alert alert-danger col-lg-12 col-md-12 col-12"
                      style="font-size: 13px;"
                      v-show="checkq_result === 2"
                    >
                      <i class="icon-sad-tear1"></i>

                      <strong>ขออภัยค่ะ !</strong>
                      {{checkq_message}}
                    </div>
                    <div
                      v-if="checkq_validated === 1"
                      class="button button-medium button-border button-rounded"
                      @click="addToCart()"
                    >
                      <i class="icon-shopping-cart"></i>เพิ่มสินค้าลงตะกร้า
                    </div>
                    <div v-else>
                      <div>
                        <i class="icon-shopping-cart"></i>เพิ่มสินค้าลงตะกร้า
                      </div>
                      <div
                        class="alert alert-info col-lg-12 col-md-12 col-12"
                        style="font-size: 13px;"
                      >
                        <i class="icon-hand-up"></i>
                        <strong>เช็คคิวสินค้า !</strong> ระบุสี ขนาด สาขาที่ต้องการรับ วันรับและคืนสินค้า
                      </div>
                    </div>
                  </div>

                  <br />
                  <!-- <h2 style="margin-top: 5px; margin-bottom: -2px;color: green;">สถานะ : ว่าง</h2> -->

                  <div class="clear"></div>
                  <!-- <div class="line"></div> -->
                </div>
              </div>
            </div>

            <div class="clear"></div>
            <div class="line"></div>

            <!-- PART รีวิวสินค้า -->
            <div class="row" style="width:100%;">
              <div
                class="product_review col-lg-12 col-md-12 col-lg-11"
                style="margin-left: auto; margin-right:auto; text-align: left;"
              >
                <h1 id="review-product" style="padding-left:20px; font-size:2.0rem;">ข้อมูลเพิ่มเติม</h1>
                <div v-if="reviews.length > 0" class="product_review">
                  <div
                    class="row"
                    style="margin-top:50px;"
                    v-for="(rev,revind) in reviews"
                    :key="revind"
                  >
                    <div class="col-lg-11 col-md-11 col-11">
                      <img
                        :src="getReviewPath(rev.fileName)"
                        style="width: 100%;"
                        class="item_reviewed"
                      />
                    </div>
                  </div>
                </div>
                <div v-else class="product_review">
                  <div class="row">
                    <div class="col-lg-11 col-md-11 col-11">
                      <img
                        :src="getFullPath('default_review.jpg')"
                        style="width: 100%;"
                        class="item_reviewed"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- PART รีวิวสินค้า -->

            <!-- PART Basket -->
           
            <!-- PART Basket -->
          </div>
        </div>
        <!-- container container3 clearfix -->
      </div>
      <!-- ontent-wrap -->
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
import store from "@/store";
// import  { convertToArray }  from "@/utils.js";
import axios from "axios";
// import Datepicker from "vuejs-datepicker";

// import HotelDatePicker from "vue-hotel-datepicker";

export default {
  mixins: [myMixins],
  data() {
    return {
      productGroup: {},
      range: {},
      ava: "",
      optitem: 10,
      optitemSelected: 0,
      checkq_validated: 0,
      checkq_result: 0,
      checkq_message: "",
      checkq_dup: 0,
      theCheckIn: null,
      theCheckOut: null,
      startingDateValue: new Date(),
      endingDateValue: new Date(),
      colorSelected: "",
      colorShow: false,
      sizeSelected: "",
      sizeShow: false,
      rentalDateShow: false,
      optitemShow: false,
      branchSelected: "",
      branchShow: false,
      items: [],
      baseUrl: "",
      groupid: "",
      colorlist: [],
      branchlist: [],
      itemSizes: [],
      sizeOrder: ["XS","S","M","L","XL","XXL","2L","3L","4L","5L","6L","7L"],
      itemColors: [],
      theImage: "",
      main: {},
      reviews: [],
      imagelist: []
    };
  },
  async created() {
    this.groupid = this.$route.params.groupid;

    store.state.cart = JSON.parse(localStorage.getItem("rentalitem"));


    if (
      store.state.cart === null ||
      store.state.cart === undefined ||
      store.state.cart.length <= 0
    ) {
      store.state.listnumber = 0;
      store.state.cart = [];

      // this.startingDateValue = new Date();
      // this.theCheckIn = new Date();
      // this.endingDateValue = this.addDay(new Date(), 1);
      // this.theCheckOut = this.addDay(new Date(), 1);
    } else {
      store.state.listnumber = store.state.cart.length;
      // this.startingDateValue = new Date(store.state.cart[0].startDate);
      // this.theCheckIn = new Date(store.state.cart[0].startDate);
      // this.endingDateValue = new Date(store.state.cart[0].endDate);
      // this.theCheckOut = new Date(store.state.cart[0].endDate);
    }

     await this.getPosts();

     await this.getColors();
     await this.getBranch();
     await this.getAllImage();
    this.theImage =  this.imagelist[0].image;
    

     
  },

  async mounted() {
    // await this.getPosts();
    // this.getColors();

    await this.getReviews();
 
    // console.log(' await this.getColors();');
    

    this.scrollToTop();

    // this.theImage = await this.imagelist[0].image;
    // var getslide = document.getElementById("theslider");
  },
  watch: {
    range: {
      handler(value) {
        
        if (value === null) {
          this.theCheckIn = null;
          this.theCheckOut = null;
        } else {
          this.theCheckIn = this.formatDate(value.start);
          this.theCheckOut = this.formatDate(value.end);
        }
      },
      deep: true
    },

    optitemSelected() {
      this.checkq_validated = 0;
    },

    colorSelected() {
      this.resetAll();
    },
    sizeSelected() {
      this.resetAll();
    },
    branchSelected() {
      this.resetAll();
    }
  },
  methods: {
    clickdate() {
      this.theCheckIn = null;
      this.theCheckOut = null;
      this.range = {};
    },
    async addToCart() {
      this.resetAll();

      // ** CHECK DUPLICATED
      if (store.state.cart != null && store.state.cart != undefined) {
        var getfil = store.state.cart.filter(x => x.productItemId === this.ava);

        if (getfil.length > 0) {
          this.checkq_dup = true;
          var removeIndex = [];
          for (var i = 0; i < store.state.cart.length; i++) {
            if (store.state.cart[i].productItemId === this.ava) {
              removeIndex.push(i);
            }
          }

          for (var k = removeIndex.length - 1; k >= 0; k--)
            store.state.cart.splice(removeIndex[k], 1);
        }
      }
      // CHECK DUPLICATED
      // *** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
      var url =
        store.state.apiUrl + "/web-api/web/get-product-detail/" + this.ava;
      var prd = await this.getOne(url);

      var detail = {
        orderHeaderId: "",
        flag2: "w",
        size: prd.size,
        color: prd.color,
        mainImage: prd.mainImage, // *** เพิ่มเติม
        name: prd.name, // *** เพิ่มเติม
        branchId: this.branchSelected.branchId,
        productItemId: this.ava,
        code: prd.code,
        reservedQuantity: this.optitemSelected,
        rentalPrice: prd.rentalPrice,
        bail: prd.bail,
        state: true,
        startDate: this.formatDate(this.theCheckIn),
        endDate: this.formatDate(this.theCheckOut),
        createBy: "webuser",
        updateBy: "webuser"
      };

      store.state.cart.push(detail);
      localStorage.setItem("rentalitem", JSON.stringify(store.state.cart));

      var it = JSON.parse(localStorage.getItem("rentalitem"));

      if (it !== null && it !== undefined) {
        store.state.listnumber = it.length;
      } else {
        store.state.listnumber = 0;
      }

      store.state.listnumber = it.length;
    },
    resetAll() {
      this.checkq_validated = 0;
      this.checkq_result = 0;
      this.checkq_message = "";
      this.checkq_dup = false;
    },
    async checkq() {
      this.checkq_result = 0;
      this.checkq_validated = 0;
      this.checkq_message = "";
      this.checkq_dup = false;

      this.colorShow = false;
      this.sizeShow = false;
      this.branchShow = false;
      this.optitemShow = false;
      this.rentalDateShow = false;

      if (
        this.colorSelected === "" ||
        this.colorSelected === null ||
        this.colorSelected === undefined
      ) {
        this.colorShow = true;
      }

      if (
        this.sizeSelected === "" ||
        this.sizeSelected === null ||
        this.sizeSelected === undefined
      ) {
        this.sizeShow = true;
      }

      if (
        this.branchSelected === "" ||
        this.branchSelected === null ||
        this.branchSelected === undefined
      ) {
        this.branchShow = true;
      }

      if (
        this.theCheckIn === "" ||
        this.theCheckIn === null ||
        this.theCheckIn === undefined ||
        this.theCheckOut === "" ||
        this.theCheckOut === null ||
        this.theCheckOut === undefined
      ) {
        this.rentalDateShow = true;
      }

      if (
        this.optitemSelected === "" ||
        this.optitemSelected === null ||
        this.optitemSelected === undefined ||
        this.optitemSelected === 0
      ) {
        this.optitemShow = true;
      }

      if (
        !this.colorSelected ||
        !this.sizeSelected ||
        !this.branchSelected ||
        !this.optitemSelected ||
        this.rentalDateShow
      ) {
        return;
      }

      var fil = this.items.filter(
        x =>
          x.size === this.sizeSelected.toString() &&
          x.color === this.colorSelected.toString()
      );

      // There is an ITEM in combination SIZE and COLOR
      // มีสินค้าหลัง filter ด้วย สีและขนาด
      if (fil.length >= 1) {
        var ci = [
          {
            productItemId: fil[0].productItemId,
            pickupDate: this.formatDate(this.theCheckIn),
            returnDate: this.formatDate(this.theCheckOut),
            branchId: this.branchSelected.branchId,
            qty: this.optitemSelected
          }
        ];

        // console.log('ci ********>>>>>> ',ci);
        

        var res = null;
        try {
          res = await axios.post(
            // "https://wintershop-online.com/api/orderdetail/checkq",
           store.state.apiUrl +  "/web-api/web/checkq",
            ci,
            store.state.apiHeader
          );
        } catch (err) {
          res = null;
        }

        if (res !== null) {
          if (res.data.length > 0) {
            if (res.data[0].result === 1) {
              this.checkq_validated = 1;
              this.checkq_result = 1;
              this.ava = res.data[0].productItemId;
              //  สินค้ามีให้เช่าได้
            } else {
              this.checkq_validated = 0;
              this.checkq_result = 2;
              this.ava = "";
              //  สินค้ามีไม่พอ
            }
            this.checkq_message = res.data[0].desc;
            // ** CHECK DUPLICATED
            if (store.state.cart != null && store.state.cart != undefined) {
              var getfil = store.state.cart.filter(
                x => x.productItemId === this.ava
              );

              if (getfil.length > 0) {
                this.checkq_dup = true;
              }
            }
            // CHECK DUPLICATED
          } else {
            this.ava = "";
          }
        }
      } else {
        this.checkq_result = 2;
        this.checkq_message = "สินค้าหมดขั่วคราว";
        this.ava = "";
      }

      //
    },
    newCheckIn: function(newDate) {
      this.theCheckIn = newDate;

      for (var i = 0; i < store.state.cart.length; i++) {
        store.state.cart[i].startDate = this.formatDate(newDate);
      }

      localStorage.setItem("rentalitem", JSON.stringify(store.state.cart));
    },
    newCheckOut: function(newDate) {
      this.theCheckOut = newDate;

      for (var i = 0; i < store.state.cart.length; i++) {
        store.state.cart[i].endDate = this.formatDate(newDate);
      }

      localStorage.setItem("rentalitem", JSON.stringify(store.state.cart));
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async getAllImage() {
      for (var i = 0; i < this.items.length; i++) {
        var co = this.imagelist.filter(x => x.color === this.items[i].color);
        if (
          co.length === 0 &&
          (this.items[i].mainImage !== null ||
            this.items[i].mainImage !== undefined ||
            this.items[i].mainImage !== "")
        ) {
          var obj = {
            image: this.items[i].mainImage,
            color: this.items[i].color
          };

          this.imagelist.push(obj);
        }
      }
    },

    getColorName(code) {
      var res = this.colorlist.find(c => c.code === code);
      if (res === undefined || res === null) {
        return "ไม่ระบุ";
      } else {
        return res.description;
      }
    },

    formatPrice(value) {
      value = this.convertToNum(value);
      var amount = isNaN(value) ? 0 : value;

      return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    convertToNum(value) {
      if (typeof value === "string") {
        value = Number(value.replace(",", ""));
      }
      if (isNaN(value)) {
        value = 0;
      }
      return value;
    },
    changeImage(list) {
      this.theImage = list.image;
      this.selectColor(list.color);
    },
    selectSize(size) {
      this.sizeSelected = size;
    },
    selectColor(color) {
      var have = this.imagelist.find(x => x.color === color);

      this.colorSelected = color;

      this.theImage = have.image;
    },
    selectBranch(brn) {
      this.branchSelected = brn;
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },

    async getColors() {

      var res = await axios.post( store.state.apiUrl +  "/web-api/web/colors", store.state.apiHeader);


      this.colorlist = res.data;
        

    },
    async getBranch() {
      // axios.get(store.state.apiUrl +  "/api/branch").then(response => {
      //   this.branchlist = response.data;
      // });
      var res = await axios.post( store.state.apiUrl +  "/web-api/web/branches", {} , store.state.apiHeader);
      this.branchlist = res.data;
    },
    async getReviews() {
      var response = await axios.post(
        store.state.apiUrl +  "/web-api/web/review-image" ,  {t1: this.groupid},  store.state.apiHeader
      );

      this.reviews = await response.data;
    },
    async getPosts() {
      //   let url = buildUrl();
      var response = await axios.post(
       store.state.apiUrl +  "/web-api/web/groupone"
           , {t1: this.groupid}, store.state.apiHeader
      );

      this.productGroup = response.data.ProductGroup;
      // console.log('this.productGruou >>>> ',this.productGroup);
      
      this.items =  response.data.ProductList;

      // ******** set size array 
      let list_for_size =  [];
      Object.assign(list_for_size, response.data.ProductList);
      // this.itemSizes =    this.convertToArray(list_for_size , "size");
      
      let tempSize = [];
      
      tempSize = this.convertToArray(list_for_size , "size");
      // console.log('tempSize >>> ',tempSize);

      let tmp = [];
      let outOfTmp = [];

      for(let i=0; i < tempSize.length; i++ )
      {
        let sob = {};
        let sq = this.sizeOrder.indexOf(tempSize[i].toUpperCase());
        
        // ถ้าไม่มีใน list การเรียงให้เอาไปไว้ที่  outOfTmp
        if(sq === -1)
        {
          outOfTmp.push(tempSize[i])
        }
        else{
          sob.seq = sq;
          sob.val = tempSize[i];
          tmp.push(sob);
        }
        
      }


      // console.log('tmp >>> ',tmp);

      let sortedTmp = this.ascendingSortShare(tmp, "seq");

      sortedTmp.forEach(element => {
          this.itemSizes.push(element["val"])
      });

      outOfTmp.forEach(element => {
          this.itemSizes.push(element)
      });

      // console.log('this.itemSizes >>> ',this.itemSizes);
      
      // Make it unique array
      this.itemSizes =  this.itemSizes.filter(this.onlyUnique);



      // ******** set color array 
      let list_for_color =  [];
      Object.assign(list_for_color, response.data.ProductList);
      this.itemColors =  this.convertToArray(list_for_color , "color");
      this.itemColors =  this.itemColors.filter(this.onlyUnique);

      
     
      // console.log(' this.itemSizes   >>>>>>> ',this.itemSizes );
      // console.log(' this.itemColors  >>>>>>> ',this.itemColors );

      // Make it unique array

      // var mainres = await axios.get(
      //  store.state.apiUrl +   "/api/productitem/" + this.groupid
      // );

      this.main = await this.items;
    },
    imagePath(mainImage) {
      if (mainImage === undefined || mainImage === null || mainImage === "") {
        return store.state.apiImageUrl +  "defaultimage.png";
      } else {
        return store.state.apiImageUrl +  "item/" + mainImage;
      }
    },
    getReviewPath(mainImage) {
      if (mainImage === undefined || mainImage === null || mainImage === "") {
        return  store.state.apiImageUrl +  "defaultimage.png";
      } else {
        return store.state.apiImageUrl +   "review/" + mainImage;
      }
    }
  },
  components: {
    // Datepicker
    // HotelDatePicker
  }
};
</script>
 
<style >
.con-vs-popup .vs-popup .datepicker__month-day {
  visibility: visible;
  text-align: center;
  margin: 0;
  border: 0;
  height: 25px;
  padding-top: 5px !important;
  vertical-align: middle;
}

.notChoose {
  color: #444;
  background-color: white;
}

.choose {
  color: white !important;
  background-color: #444 !important;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 3px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #d8d8d8a8;
  border-radius: 10px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
}

.button.button-border {
  border: 1px solid #c7c7c7;
  background-color: transparent;
  color: #333;
  line-height: 36px;
  font-weight: 700;
  font-size: 12px;
  text-shadow: none;
}
.product-desc {
  font-family: "Mitr", sans-serif !important;
}
.nc_size {
  border: 1px solid #c7c7c7;
  background-color: white;
}
.c_size {
  border: 1px solid #c7c7c7;
  background-color: #333;
}

.button-medium {
  font-family: "Mitr", "supermarket" !important;
  font-size: 14px !important;
  font-weight: 300 !important;
}

/************* VUE HOTEL DATEPICKUP **************/
@media screen and (min-width: 768px) {
  .datepicker__months {
    /* FONT-WEIGHT: 100; */
    width: 500px !important;
  }
}
.con-vs-popup .vs-popup .datepicker__month-day {
  visibility: visible;
  text-align: center;
  margin: 0;
  border: 0;
  height: 25px;
  padding-top: 5px !important;
  vertical-align: middle;
}

.con-vs-popup .vs-popup .datepicker {
  left: -285px;
  padding: 0 10px;
  z-index: 999 !important;
}

.datepicker__input {
  font-size: 12px !important;
  line-height: 4 !important;
  padding: 4px 25px 2px !important;
}

.con-vs-popup .vs-popup {
  width: 750px;
}

.datepicker.datepicker--closed {
  display: none;
}
/* .con-vs-popup .vs-popup .datepicker__inner {
  padding: 0;
  float: left;
  padding-bottom: 5px;
} */

.con-vs-popup .vs-popup .datepicker__month-day {
  visibility: visible;
  text-align: center;
  margin: 0;
  border: 0;
  height: 25px;
  padding-top: 5px !important;
  vertical-align: middle;
}

.con-vs-popup .vs-popup .datepicker__week-row {
  border-bottom: 5px solid #fff;
  height: 20px;
}
.con-vs-popup .vs-popup .datepicker {
  left: -285px !important;
  padding: 0 10px;
  z-index: 999 !important;
}

.zoomimage {
  width: 400px;
}
.datepicker__tooltip {
  display: none !important;
}

.demo-alignment {
  vertical-align: middle;
}

.datepicker__tooltip {
  display: none;
}
@media only screen and (min-width: 900px) {
  .product_review {
    max-width: 700px !important;
  }
}
@media only screen and (max-width: 900px) {
  .product-desc {
    margin-top: 20px !important;
  }
  #imageselect {
    padding-left: 20px !important;
    padding-right: 0 !important;
  }
  #basket_container {
    left: 70% !important;
  }
}
@media only screen and (max-width: 578px) {
  #basket_container {
    left: 70% !important;
  }

  #review-product {
    padding-left: 20px !important;
  }
  .alert-info {
    font-size: 12px !important;
  }
  .product {
    max-width: 578px !important;
    height: fit-content !important;
  }
  .product-desc {
    max-width: 520px !important;
    margin-top: 20px !important;
    padding-left: 40px !important;
  }
  #imageselect {
    padding-left: 20px !important;
    padding-right: 0 !important;
  }
  #mainimage_wrapper {
    text-align: left !important;
    padding-left: 20px !important;
  }
  #mainimage {
    max-width: 95% !important;
  }
  .oc-item {
    margin-right: 60px !important;
  }

  .container {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .product_review {
    padding-left: 20 !important;
    padding-right: 20 !important;
    /* max-width: 300px !important; */
  }
  .item_reviewed {
    max-width: 95% !important;
    height: auto !important;
  }
  .image_fade {
    width: 100% !important;
  }
  .dis_btn {
    position: relative;
    cursor: pointer;
    outline: none;
    white-space: nowrap;
    margin: 5px;
    padding: 0 22px;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    background-color: #909392;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
    font-family: Mitr !important;
    font-size: 14px !important;
    font-weight: 300 !important;
    line-height: 42px;
    transition: all 0.2s ease-in-out;
    border-radius: 3px;
    padding: 0 26px;
    border: 2px solid #444 !important;
    color: #333;
    line-height: 36px;
    font-weight: 700;
    text-shadow: none;
  }
}
</style>